import React, { useEffect } from "react";

import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import Icon from "@mui/material/Icon";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import FileInput from "./FileInput";
import DeleteModal from "../DeleteModal";

import Moment from "react-moment";
import DataTable from "examples/Tables/DataTable";
import EditDoe from "customComponents/devicesComponents/EditDoe";

import { API_URL } from "../../../config/apiUrl";

import { putDevice, getDevice } from "../../../api/devices";

import { getOrder } from "../../../api/orders";

import { useDispatch, useSelector } from "react-redux";

import { setCurrentOrder } from "../../../redux/reducers/ordersReducer";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";

import { canEditOrder } from "../../../utils/permissions";

export default function DoeTable({ device, user }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  const dispatch = useDispatch();

  const currentOrder = useSelector((state) => state.orders.currentOrder);
  const canEdit = canEditOrder(user, currentOrder);

  const fileDownload = `${API_URL}files/${device.device_number}-DOE.pdf?api_key=${
    process.env.REACT_APP_NGT_API_KEY
  }&session_token=${localStorage.getItem("sessionToken")}`;

  async function updateDeviceAPI(device, deviceId) {
    await putDevice(device, deviceId);
    const orderResponse = await getOrder(currentOrder.order_id);
    dispatch(setCurrentOrder(orderResponse.data));
    const deviceResponse = await getDevice(deviceId);
    return await deviceResponse.data;
  }

  const contractColumns = [
    { Header: "DOE", accessor: "doe", align: "center" },
    { Header: "Fichier du DOE", accessor: "file", align: "center" },
  ];
  const contractRows = [
    {
      doe: (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
          {device && device.doe_sent_date !== null ? (
            <MDBox lineHeight={1}>
              <MDTypography variant="caption">Envoyé le</MDTypography>
              <MDTypography display="block" variant="string" fontWeight="medium">
                <Moment format="DD/MM/YYYY">{device && device.doe_sent_date}</Moment>
              </MDTypography>
            </MDBox>
          ) : (
            <MDTypography display="block" variant="caption" color="warning" fontWeight="medium">
              Non envoyé
            </MDTypography>
          )}
        </MDBox>
      ),
      file: (
        <MDBox display="flex" flexDirection="column" alignItems="start" lineHeight={1}>
          {device && device.doe_filename !== null ? (
            <MDBox sx={{ alignText: "center" }}>
              <MDBox lineHeight={1}>
                <a href={fileDownload} download>
                  <MDTypography
                    sx={{
                      "&:hover": {
                        textDecoration: "underline",
                      },
                      display: "table-cell",
                      verticalAlign: "middle",
                      textAlign: "center",
                    }}
                    display="block"
                    variant="body2"
                    fontWeight="medium"
                    underline="hover"
                  >
                    <Icon sx={{ verticalAlign: "middle" }}>download</Icon> {device.doe_filename}
                  </MDTypography>
                </a>
              </MDBox>
              {canEdit && (
                  <DeleteModal
                    message={`ce fichier`}
                    onOk={() => {
                      fetch(`${API_URL}files/${device.doe_filename}`, {
                        method: "DELETE",
                        headers: {
                          "X-API-KEY": process.env.REACT_APP_NGT_API_KEY,
                          Authorization: "Bearer " + localStorage.getItem("sessionToken"),
                        },
                      });
                      updateDeviceAPI(
                        {
                          doe_filename: null,
                        },
                        device.device_id
                      );
                    }}
                    type="file"
                  />
                )}
            </MDBox>
          ) : (
            <FileInput device={device} fileDescription="-DOE" />
          )}
        </MDBox>
      ),
    },
  ];
  return (
    <Grid item lg={12} md={12} sm={12} xs={12} height="100%">
      <Card sx={{ height: "100%" }}>
        <MDBox
          mx={2}
          mt={-3}
          py={1.5}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={{
            background: !darkMode ? "linear-gradient(195deg, #364c70, #273956)" : "white",
            boxShadow: darkMode ? "0 1px 4px 1px white" : "0 1px 4px 1px #344767",
            display: "flex",
            verticalAlign: "middle",
          }}
        >
          <MDTypography
            variant="h5"
            style={{
              width: "75%",
              lineHeight: "2.4rem",
              display: "tableCell",
              verticalAlign: "middle",
            }}
            color={darkMode ? "inherit" : "white"}
          >
            DOE
          </MDTypography>
          {canEdit && (
              <Grid style={{ textAlign: "right", width: "25%" }}>
                <EditDoe device={device} edit={true} renderStep={0} />
              </Grid>
            )}
        </MDBox>
        <MDBox
          pt={0.75}
          sx={{
            height: "100%",
            "div.MuiTableContainer-root": {
              height: "100%",
              display: "flex",
            },
          }}
        >
          <DataTable
            table={{ columns: contractColumns, rows: contractRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>
      </Card>
    </Grid>
  );
}
